import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const merchantBeggen: NarratorNPC = {
  id: 'merchant-beggen',
  name: 'Merchant',
  dialog: dialog,
};
